import React from 'react';
export function Cost() {
  return <section className="py-[60px] px-5 bg-brand-dark" data-id="element-1">
      <div className="max-w-[860px] mx-auto" data-id="element-2">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-3">
          El Costo de No Actuar
        </h2>
        <p className="text-base text-brand-gray text-center mb-10 max-w-[600px] mx-auto" data-id="element-4">
          Cada semana sin sistema tiene un costo real en dólares
        </p>

        <table className="w-full border-collapse max-w-[560px] mx-auto mb-7 rounded-xl overflow-hidden" data-id="element-5">
          <thead data-id="element-6">
            <tr data-id="element-7">
              <th className="bg-brand-red/20 text-brand-red text-[13px] uppercase tracking-[1px] p-3 px-4.5 text-left" data-id="element-8">
                Concepto
              </th>
              <th className="bg-brand-red/20 text-brand-red text-[13px] uppercase tracking-[1px] p-3 px-4.5 text-left" data-id="element-9">
                Costo Mensual Sin Sistema
              </th>
            </tr>
          </thead>
          <tbody data-id="element-10">
            <tr data-id="element-11">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-12">
                Late fees promedio
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-red font-bold text-right" data-id="element-13">
                $75–$150
              </td>
            </tr>
            <tr data-id="element-14">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-15">
                Suscripciones no usadas
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-red font-bold text-right" data-id="element-16">
                $50–$200
              </td>
            </tr>
            <tr data-id="element-17">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-18">
                Fees de remesas en exceso
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-red font-bold text-right" data-id="element-19">
                $28–$40
              </td>
            </tr>
            <tr data-id="element-20">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5]" data-id="element-21">
                Intereses pagando solo mínimo
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-red font-bold text-right" data-id="element-22">
                $40–$120
              </td>
            </tr>
            <tr data-id="element-23">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-[#cdd9e5] font-bold" data-id="element-24">
                TOTAL MENSUAL
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border text-brand-red font-bold text-right" data-id="element-25">
                $193–$510
              </td>
            </tr>
            <tr className="bg-brand-red/10 font-black text-[15px] text-brand-red" data-id="element-26">
              <td className="p-3 px-4.5 border-t border-brand-border" data-id="element-27">
                TOTAL ANUAL
              </td>
              <td className="p-3 px-4.5 border-t border-brand-border text-right" data-id="element-28">
                $2,316–$6,120
              </td>
            </tr>
          </tbody>
        </table>

        <div className="max-w-[500px] mx-auto text-center" data-id="element-29">
          <p className="text-[15px] text-[#cdd9e5] leading-[1.6]" data-id="element-30">
            <strong className="text-white text-[17px]" data-id="element-31">
              Este libro cuesta $6.39.
            </strong>
          </p>
          <p className="text-[15px] text-[#cdd9e5] leading-[1.6]" data-id="element-32">
            No tenerlo te puede costar{' '}
            <strong className="text-white text-[17px]" data-id="element-33">$2,316 al año.</strong>
          </p>
        </div>
      </div>
    </section>;
}